import TOS from 'routes/TOS'

export default TOS
